import { EMPTY_STRING } from '../../../constants/common'

export function getPhaseBarStatusText() {
  return null
}

export function getPhaseBarTooltipAdditionalText() {
  return EMPTY_STRING
}
